import Vue from 'vue'
import App from './Index.vue'
import '../common'
import {getHibirdConfig, initJSBridge, sendData} from "@/utils/JSBridge";
import {pageConfig} from "@/config/clientPageConfig";

initJSBridge(function (bridge) {

});

console.log(getHibirdConfig(pageConfig.bridgeConfig))
sendData(getHibirdConfig(pageConfig.bridgeConfig));

new Vue({
  render: h => h(App)
}).$mount('#app')
